<script>
  import { accountProfileSection } from './account-profile.js';
  import { profileFields, fullNameFromProfile } from './account-profile.js';
  import { profileSyncFailure, dismissProfileSyncWarning } from '../stores/account.js';

  export let profile = null;

  $: values = profileFields(profile);
  $: displayName = fullNameFromProfile(profile) || accountProfileSection.fallbackName;
</script>

<section class="profile" aria-labelledby="profile-title">
  <p class="kicker">{accountProfileSection.kicker}</p>
  <h2 id="profile-title">{displayName}</h2>

  {#if $profileSyncFailure}
    <div class="sync-warning" role="status" aria-live="polite">
      <div class="sync-warning-body">
        <strong>Профиль сохранился не полностью</strong>
        <span>{$profileSyncFailure.reason}. Имя, фамилию или email можно поправить через организатора форума.</span>
      </div>
      <button
        class="sync-warning-dismiss"
        type="button"
        on:click={dismissProfileSyncWarning}
        aria-label="Скрыть уведомление о синхронизации профиля"
      >×</button>
    </div>
  {/if}

  <ul class="profile-list">
    {#each accountProfileSection.fields as field}
      {@const value = values[field.key]}
      <li>
        <span class="field-label">{field.label}</span>
        <span class="field-value" class:empty={!value}>
          {value || accountProfileSection.empty}
        </span>
      </li>
    {/each}
  </ul>

  <p class="hint">{accountProfileSection.editHint}</p>
</section>

<style>
  .profile {
    padding: 20px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.025);
  }

  .kicker {
    margin: 0;
    color: rgba(255, 255, 255, 0.35);
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.12em;
  }

  h2 {
    margin: 8px 0 0;
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.01em;
    overflow-wrap: anywhere;
  }

  .sync-warning {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    margin-top: 16px;
    padding: 12px 14px;
    border: 1px solid rgba(231, 185, 98, 0.3);
    border-radius: 12px;
    background: transparent;
  }

  .sync-warning-body {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 12px;
    line-height: 18px;
  }

  .sync-warning-body strong {
    color: #e7b962;
    font-size: 12px;
    font-weight: 500;
  }

  .sync-warning-body span {
    color: rgba(255, 255, 255, 0.7);
  }

  .sync-warning-dismiss {
    flex: 0 0 auto;
    width: 20px;
    height: 20px;
    border: 0;
    background: transparent;
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    padding: 0;
    transition: color 160ms ease;
  }

  .sync-warning-dismiss:hover,
  .sync-warning-dismiss:focus-visible {
    color: #ffffff;
    outline: none;
  }

  .profile-list {
    list-style: none;
    margin: 20px 0 0;
    padding: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  .profile-list li {
    padding: 12px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  .profile-list li:last-child {
    border-bottom: 0;
  }

  .field-label {
    display: block;
    color: rgba(255, 255, 255, 0.35);
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
  }

  .field-value {
    display: block;
    margin-top: 4px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    line-height: 20px;
    overflow-wrap: anywhere;
  }

  .field-value.empty {
    color: rgba(255, 255, 255, 0.35);
    font-style: italic;
  }

  .hint {
    margin: 16px 0 0;
    color: rgba(255, 255, 255, 0.4);
    font-size: 12px;
    line-height: 20px;
  }
</style>
